import type { CommercialCatalogEntry } from '../types'

/**
 * In-memory commercial catalog for sub-1-minute quoting.
 * No stock, no DB — seed data only.
 */
export const COMMERCIAL_CATALOG: CommercialCatalogEntry[] = [
  // --- Computer components ---
  {
    id: 'cmp-cpu-r5-5600',
    type: 'Component',
    slot: 'cpu',
    label: 'AMD Ryzen 5 5600',
    brand: 'AMD',
    model: 'Ryzen 5 5600',
    description: '6c/12t — AM4',
    unitCost: 720,
    unitPrice: 899,
    tags: ['desktop', 'office', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-cpu-i5-12400f',
    type: 'Component',
    slot: 'cpu',
    label: 'Intel Core i5-12400F',
    brand: 'Intel',
    model: 'i5-12400F',
    description: '6c/12t — LGA1700',
    unitCost: 780,
    unitPrice: 979,
    tags: ['desktop', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-mb-b550m',
    type: 'Component',
    slot: 'motherboard',
    label: 'Placa-mãe B550M',
    brand: 'Gigabyte',
    model: 'B550M DS3H',
    description: 'AM4 mATX',
    unitCost: 520,
    unitPrice: 679,
    tags: ['desktop', 'am4'],
    active: true,
  },
  {
    id: 'cmp-mb-b660m',
    type: 'Component',
    slot: 'motherboard',
    label: 'Placa-mãe B660M',
    brand: 'MSI',
    model: 'PRO B660M-A',
    description: 'LGA1700 mATX',
    unitCost: 580,
    unitPrice: 749,
    tags: ['desktop', 'lga1700'],
    active: true,
  },
  {
    id: 'cmp-ram-16-3200',
    type: 'Component',
    slot: 'ram',
    label: 'Memória 16GB DDR4 3200',
    brand: 'Kingston',
    model: 'Fury 2x8GB',
    description: 'DDR4-3200',
    unitCost: 210,
    unitPrice: 289,
    tags: ['desktop', 'office', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-ram-32-3200',
    type: 'Component',
    slot: 'ram',
    label: 'Memória 32GB DDR4 3200',
    brand: 'Kingston',
    model: 'Fury 2x16GB',
    description: 'DDR4-3200',
    unitCost: 390,
    unitPrice: 529,
    tags: ['desktop', 'gamer', 'workstation'],
    active: true,
  },
  {
    id: 'cmp-ssd-500',
    type: 'Component',
    slot: 'storage',
    label: 'SSD NVMe 500GB',
    brand: 'WD',
    model: 'SN770 500GB',
    description: 'NVMe Gen4',
    unitCost: 230,
    unitPrice: 319,
    tags: ['desktop', 'office'],
    active: true,
  },
  {
    id: 'cmp-ssd-1tb',
    type: 'Component',
    slot: 'storage',
    label: 'SSD NVMe 1TB',
    brand: 'WD',
    model: 'SN770 1TB',
    description: 'NVMe Gen4',
    unitCost: 380,
    unitPrice: 499,
    tags: ['desktop', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-gpu-integrated',
    type: 'Component',
    slot: 'gpu',
    label: 'Vídeo integrado',
    brand: 'AMD',
    model: 'iGPU',
    description: 'Sem GPU dedicada',
    unitCost: 0,
    unitPrice: 0,
    tags: ['desktop', 'office'],
    active: true,
  },
  {
    id: 'cmp-gpu-rtx4060',
    type: 'Component',
    slot: 'gpu',
    label: 'GeForce RTX 4060 8GB',
    brand: 'NVIDIA',
    model: 'RTX 4060',
    description: '8GB GDDR6',
    unitCost: 1450,
    unitPrice: 1899,
    tags: ['desktop', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-psu-550',
    type: 'Component',
    slot: 'psu',
    label: 'Fonte 550W 80+ Bronze',
    brand: 'Corsair',
    model: 'CV550',
    description: '550W Bronze',
    unitCost: 280,
    unitPrice: 369,
    tags: ['desktop', 'office'],
    active: true,
  },
  {
    id: 'cmp-psu-650',
    type: 'Component',
    slot: 'psu',
    label: 'Fonte 650W 80+ Bronze',
    brand: 'Corsair',
    model: 'CX650',
    description: '650W Bronze',
    unitCost: 340,
    unitPrice: 449,
    tags: ['desktop', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-case-matx',
    type: 'Component',
    slot: 'case',
    label: 'Gabinete mATX',
    brand: 'Rise Mode',
    model: 'Glass 06X',
    description: 'mATX com vidro',
    unitCost: 180,
    unitPrice: 249,
    tags: ['desktop', 'office', 'gamer'],
    active: true,
  },
  {
    id: 'cmp-cooler-stock',
    type: 'Component',
    slot: 'cooler',
    label: 'Cooler box',
    brand: 'OEM',
    model: 'Stock',
    description: 'Cooler incluso CPU',
    unitCost: 0,
    unitPrice: 0,
    tags: ['desktop', 'office'],
    active: true,
  },
  // --- Finished commercial goods ---
  {
    id: 'nb-office-15',
    type: 'Notebook',
    label: 'Notebook Escritório 15"',
    brand: 'Lenovo',
    model: 'IdeaPad 3i',
    description: 'i5 / 8GB / 256GB SSD',
    unitCost: 2100,
    unitPrice: 2799,
    tags: ['notebook', 'office'],
    active: true,
  },
  {
    id: 'mon-24-ips',
    type: 'Monitor',
    label: 'Monitor 24" IPS',
    brand: 'LG',
    model: '24MS500',
    description: 'Full HD IPS 100Hz',
    unitCost: 520,
    unitPrice: 699,
    tags: ['monitor', 'office'],
    active: true,
  },
  {
    id: 'prt-laser-mono',
    type: 'Printer',
    label: 'Impressora Laser Mono',
    brand: 'Brother',
    model: 'HL-1212W',
    description: 'Laser Wi-Fi',
    unitCost: 780,
    unitPrice: 999,
    tags: ['printer', 'office'],
    active: true,
  },
  {
    id: 'per-kb-mouse',
    type: 'Peripheral',
    label: 'Kit teclado + mouse',
    brand: 'Logitech',
    model: 'MK270',
    description: 'Wireless',
    unitCost: 95,
    unitPrice: 149,
    tags: ['peripheral', 'office'],
    active: true,
  },
  {
    id: 'sw-office-365',
    type: 'Software',
    label: 'Microsoft 365 Apps',
    brand: 'Microsoft',
    model: 'Apps for business',
    description: 'Assinatura anual (referência)',
    unitCost: 280,
    unitPrice: 399,
    tags: ['software', 'office'],
    active: true,
  },
  {
    id: 'lic-win11-pro',
    type: 'License',
    label: 'Windows 11 Pro OEM',
    brand: 'Microsoft',
    model: 'Win11 Pro',
    description: 'Licença OEM',
    unitCost: 520,
    unitPrice: 699,
    tags: ['license', 'os'],
    active: true,
  },
  {
    id: 'svc-montagem',
    type: 'Service',
    label: 'Montagem e testes',
    brand: 'MasterHub',
    model: 'SVC-MONT',
    description: 'Montagem + stress test',
    unitCost: 0,
    unitPrice: 150,
    tags: ['service', 'desktop'],
    active: true,
  },
  {
    id: 'svc-instalacao',
    type: 'Service',
    label: 'Instalação no cliente',
    brand: 'MasterHub',
    model: 'SVC-INST',
    description: 'Instalação on-site',
    unitCost: 40,
    unitPrice: 180,
    tags: ['service'],
    active: true,
  },
]

export class CommercialCatalog {
  private readonly entries: CommercialCatalogEntry[]

  constructor(entries: CommercialCatalogEntry[] = COMMERCIAL_CATALOG) {
    this.entries = entries
  }

  list(options?: {
    type?: CommercialCatalogEntry['type']
    slot?: CommercialCatalogEntry['slot']
    tag?: string
    activeOnly?: boolean
  }): CommercialCatalogEntry[] {
    const activeOnly = options?.activeOnly ?? true
    return this.entries.filter((e) => {
      if (activeOnly && !e.active) return false
      if (options?.type && e.type !== options.type) return false
      if (options?.slot && e.slot !== options.slot) return false
      if (options?.tag && !e.tags.includes(options.tag)) return false
      return true
    })
  }

  getById(id: string): CommercialCatalogEntry | undefined {
    return this.entries.find((e) => e.id === id)
  }

  search(term: string, limit = 20): CommercialCatalogEntry[] {
    const q = term.trim().toLowerCase()
    if (!q) return this.list().slice(0, limit)
    return this.list()
      .filter(
        (e) =>
          e.label.toLowerCase().includes(q) ||
          e.brand.toLowerCase().includes(q) ||
          e.model.toLowerCase().includes(q) ||
          e.tags.some((t) => t.includes(q)),
      )
      .slice(0, limit)
  }
}

export const commercialCatalog = new CommercialCatalog()
